import React from 'react';
import {
    Heading,
    Flex,
    Box,
    Text
} from '@chakra-ui/react';
import { PrismicRichText } from "@prismicio/react"
import CtaButton from '../CtaButton/CtaButton';

import styled from '@emotion/styled';



export default function LogoCallToAction({ slice }) {

    // Color the RichText based on the editor's color choice
    const textColor = slice.primary.text_area_text_color;

    const StyledText = styled(Box)`
        > * {
            color: ${textColor};
        }
    `;

    return (
            <Box as="section">
                {slice.primary.align === true ? (
                    <Flex flexDirection={{base: 'column', md: 'row'}} flexWrap="wrap" w="100%" bg={slice.primary.text_area_background_color} h="100%" alignItems="stretch">
                        <Box w={{base: '100%', md: '40%'}} bg={slice.primary.image_area_background_color}>
                    {slice.primary.full_width_image ? (
                        <Box className='news-carousel-image-box'>
                        <img src={slice.primary.logo.localFile.publicURL} alt={slice.primary.logo.alt} style={{marginLeft: 'auto', marginRight: 'auto', width: '100%'}} />
                    </Box>
                    ) : (<Flex flexDirection="column" h="100%" justifyContent="center" p="16" className='news-carousel-image-box'>
                        <img src={slice.primary.logo.localFile.publicURL} alt={slice.primary.logo.alt} style={{marginLeft: 'auto', marginRight: 'auto', width: '100%'}} />
                    </Flex>)}
                    </Box>
                    <Box bg={slice.primary.text_area_background_color} w={{base: '100%', md: '60%'}}>
                        <Flex flexDirection="column" h="100%" justifyContent="center"  px={{base: 4, md: 16, lg: 24}} my={{base: 4, md: 0}} py="16">
                            <StyledText textAlign="center" px={{base: 2, lg: 16}} py="2" fontSize={{base: "1.125rem", md: "1.5rem", lg: "2rem"}} color={slice.primary.text_area_text_color}>
                                <PrismicRichText field={slice.primary.content.richText} />
                                {/* <Heading as="h5" variant="h5" color={slice.primary.text_area_text_color} textAlign="center">
                                    {slice.primary.content.text}
                                </Heading> */}
                            </StyledText>
                            {slice.primary.button_label && 
                            <Box textAlign="center">
                                <CtaButton
                                    buttonLabel={slice.primary?.button_label}
                                    linkTo={slice.primary.button_link?.url}
                                    variant={slice.primary.button_solid_or_outline ? 'Blue' : 'outline'}
                                    size={{base: 'sm', md: 'md', lg: 'lg'}}
                                    color="white"
                                />
                            </Box>
                            }
                        </Flex>
                    </Box>
                </Flex>
                ) : (
                        <Flex flexDirection={{base: 'column-reverse', md: 'row'}} flexWrap="wrap" w="100%" bg={slice.primary.text_area_background_color} h="100%" alignItems="stretch">
                                <Box bg={slice.primary.text_area_background_color} w={{base: '100%', md: '60%'}}>
                                    <Flex flexDirection="column" h="100%" justifyContent="center"  px={{base: 4, md: 16, lg: 24}} my={{base: 4, md: 0}}  py="16">
                                        <StyledText textAlign="center" px={{base: 2, lg: 16}} py="2" fontSize={{base: "1.125rem", md: "1.5rem", lg: "2rem"}} color={slice.primary.text_area_text_color}>
                                            <PrismicRichText field={slice.primary.content.richText} />
                                            {/* <Heading as="h5" variant="h5" color={slice.primary.text_area_text_color} textAlign="center">
                                                {slice.primary.content.text}
                                            </Heading> */}
                                        </StyledText>
                                        {slice.primary.button_label && 
                                        <Box textAlign="center">
                                            <CtaButton
                                                buttonLabel={slice.primary?.button_label}
                                                linkTo={slice.primary.button_link?.url}
                                                variant={slice.primary.button_solid_or_outline ? 'Blue' : 'outline'}
                                                size={{base: 'sm', md: 'md', lg: 'lg'}}
                                                color="white"
                                            />
                                        </Box>
                                        }
                                    </Flex>
                                </Box>
                                <Box w={{base: '100%', md: '40%'}} bg={slice.primary.image_area_background_color}>
                                {slice.primary.full_width_image ? (
                                    <Box className='news-carousel-image-box'>
                                    <img src={slice.primary.logo.localFile.publicURL} alt={slice.primary.logo.alt} style={{marginLeft: 'auto', marginRight: 'auto', width: '100%'}} />
                                </Box>
                                ) : (<Flex flexDirection="column" h="100%" justifyContent="center" p="16" className='news-carousel-image-box'>
                                    <img src={slice.primary.logo.localFile.publicURL} alt={slice.primary.logo.alt} style={{marginLeft: 'auto', marginRight: 'auto', width: '100%'}} />
                                </Flex>)}
                                </Box>
                            </Flex>
                )}
            </Box>
    )
}